import { Spinner } from '../ui';

interface BreadcrumbsProps {
  pathMenu: Array<string>;
  loading: boolean;
  showBlockingLoader: boolean;
  sendUpFolderPath: (path: string) => void;
  goToFolder: (index: number) => void;
}

const Breadcrumbs = ({
  pathMenu,
  loading,
  showBlockingLoader,
  sendUpFolderPath,
  goToFolder,
}: BreadcrumbsProps) => (
  <div className="flex flex-wrap items-start gap-1 md:order-1">
    <button
      className="flex items-center gap-1 group"
      onClick={() => sendUpFolderPath('/')}
    >
      <span className="text-xs text-gray-400 transition-all md:text-sm group-hover:text-gray-300">
        Home
      </span>
    </button>
    {pathMenu.length > 0 &&
      pathMenu.map((path, index) => (
        <button
          className="flex items-center gap-1 group"
          key={path + index}
          onClick={() => goToFolder(index)}
        >
          <span className="text-xs text-gray-400 transition-all md:text-sm group-hover:text-gray-300">{`>`}</span>
          <span
            title={path}
            className="text-xs transition-all text-gray-400 md:text-sm group-hover:text-gray-300 max-w-[120px] truncate"
          >
            {path}
          </span>
        </button>
      ))}
    {loading && !showBlockingLoader && (
      <Spinner className="w-4 h-4 ml-1 md:mt-0.5 md:w-4 md:h-4" />
    )}
  </div>
);

export default Breadcrumbs;
